import { fetchApi } from "./fetchApi";

import { QuickFilter } from "@/types/QuickFilter";

const url = "/api/serviceArea/quickFilter";

export const quickFilterApi = {
  async get(): Promise<any[]> {
    const response = await fetchApi({ method: "get", url });

    return response.data.result;
  },

  async put(quickFilterList: QuickFilter[]): Promise<string> {
    const response = await fetchApi({
      data: quickFilterList,
      method: "put",
      url,
    });

    return response.data.result;
  },
};
